export interface CouponTypeOption {
  value: string;
  label: string;
}

export const COUPON_TYPE_DISPLAY_TO_ENUM: Record<string, string> = {
  BOGOfree: 'BOGOfree',
  'Dollar Off': 'DollarOff',
  'Percent Off': 'PercentOff',
  'Spend $ on Item(s) Get X Multiplier in Points': 'SpendOnItemsGetXMultiplierInPoints',
  'Spend $ on Item(s) Get $ Rewards': 'SpendOnItemsGetDollarRewards',
  'Spend $ Item(s) Get $ Off': 'SpendOnItemsGetDollarOff',
  'Spend $ Item(s) Get % Off': 'SpendOnItemsGetPercentOff',
  'Multi-buy Get X Multiplier in Points': 'MultiBuyGetXMultiplierInPoints',
  'Buy X Get Y % Off': 'BuyXGetYPercentOff',
  'Buy X Get X % Off': 'BuyXGetXPercentOff',
  'Buy X and Y Get $ Off': 'BuyXAndYGetDollarOff',
  '$ Rewards Flat Points': 'DollarRewardsFlatPoints',
  '$ Free': 'DollarFree',
  '$ Final Price': 'DollarFinalPrice',
};

export const DEFAULT_COUPON_TYPES: CouponTypeOption[] = [
  { value: 'BOGOfree', label: 'BOGO free' },
  { value: 'DollarOff', label: 'Dollar Off' },
  { value: 'PercentOff', label: 'Percent Off' },
];

export const SCHNUCKS_COUPON_TYPES: CouponTypeOption[] = [
  { value: 'SpendOnItemsGetXMultiplierInPoints', label: 'Spend $ on Item(s) Get X Multiplier in Points' },
  { value: 'SpendOnItemsGetDollarRewards', label: 'Spend $ on Item(s) Get $ Rewards' },
  { value: 'SpendOnItemsGetDollarOff', label: 'Spend $ Item(s) Get $ Off' },
  { value: 'SpendOnItemsGetPercentOff', label: 'Spend $ Item(s) Get % Off' },
  { value: 'PercentOff', label: 'Percent Off' },
  { value: 'MultiBuyGetXMultiplierInPoints', label: 'Multi-buy Get X Multiplier in Points' },
  { value: 'DollarOff', label: 'Dollar Off' },
  { value: 'BuyXGetYPercentOff', label: 'Buy X Get Y % Off' },
  { value: 'BuyXGetXPercentOff', label: 'Buy X Get X % Off' },
  { value: 'BuyXAndYGetDollarOff', label: 'Buy X and Y Get $ Off' },
  { value: 'DollarRewardsFlatPoints', label: '$ Rewards Flat Points' },
  { value: 'DollarFree', label: '$ Free' },
  { value: 'DollarFinalPrice', label: '$ Final Price' },
];

export function getCouponTypes(orgName: string): CouponTypeOption[] {
  if (orgName?.toLowerCase() === 'schnucks') {
    return SCHNUCKS_COUPON_TYPES;
  }
  return DEFAULT_COUPON_TYPES;
}

export function normalizeCouponTypeToEnum(couponType: string | null | undefined): string | null | undefined {
  if (couponType == null || couponType === '') {
    return couponType;
  }
  return COUPON_TYPE_DISPLAY_TO_ENUM[couponType] ?? couponType;
}
